import { BankAccount } from "../BankAccount/BankAccount.type";
import { PettyCash } from "../PettyCash/PettyCash.type";
import { ReplenishmentRequest } from "../ReplenishRequest/ReplenishmentRequest.type";
import { ReplenishmentTransaction } from "../ReplenishTransaction/ReplenishmentTransaction.type";
import { ApiCallState } from "../Utils";

export type Replenishment = {
  id: number;
  user_id: number;
  petty_cash_id: number;
  replenishment_request_id: number;
  bank_account_id: number;

  type: string;
  from: string;

  payment_type: string;
  transaction_number: string;

  amount: number;
  current_amount: number;

  date: Date;

  bank_account: BankAccount;
  replenishment_request: ReplenishmentRequest;
  petty_cash: PettyCash;
  replenishment_transactions: ReplenishmentTransaction[];

  readonly createdAt: Date;
  readonly updatedAt: Date;
};

export type ReplenishmentStateTypes = {
  fetchAll: ApiCallState<Replenishment[]>;
  fetchOne: ApiCallState<Replenishment | {}>;
};

export const ReplenishmentActionTypes = {
  FETCH_ALL_REPLENISHMENT: "FETCH_ALL_REPLENISHMENT",
  FETCH_ALL_REPLENISHMENT_RESET: "FETCH_ALL_REPLENISHMENT_RESET",
  FETCH_ALL_REPLENISHMENT_FAILURE: "FETCH_ALL_REPLENISHMENT_FAILURE",
  FETCH_ALL_REPLENISHMENT_SUCCESS: "FETCH_ALL_REPLENISHMENT_SUCCESS",

  FETCH_ONE_REPLENISHMENT: "FETCH_ONE_REPLENISHMENT",
  FETCH_ONE_REPLENISHMENT_RESET: "FETCH_ONE_REPLENISHMENT_RESET",
  FETCH_ONE_REPLENISHMENT_FAILURE: "FETCH_ONE_REPLENISHMENT_FAILURE",
  FETCH_ONE_REPLENISHMENT_SUCCESS: "FETCH_ONE_REPLENISHMENT_SUCCESS",
};
